export const CHANGE_LANGUAGE = 'i18n/CHANGE_LANGUAGE';
